import React from 'react';
import '../styles/Header.css'; // keep this if you have header styles you might reuse

const Header = () => {
  return null; // render nothing
};

export default Header;
